import axios from 'axios';
import { BASE_URL } from './apiconfig';

export const getTubModels = async (token: string | null, params:string) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/tub-models?${params}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    throw error;
  }
}